// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3988":"a1dba7a6","4303":"bca58e98","5115":"5d418141"}[chunkId] + ".chunk.css";
};